import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

const STALE_TIME = 5 * 60 * 1000

export interface ClientFieldsResponse {
  buildingNumber: string[]
  floor: string[]
}

export interface YardiPropertyIdItem {
  yardiPropertyId: string
}

export const getClientFieldsQueryKey = (buildingId?: number) => ['useGetClientFields', buildingId]

export const getYardiPropertyIdsQueryKey = (buildingId?: number) => [
  'useGetYardiPropertyIds',
  buildingId,
]

export const useGetClientFields = (buildingId?: number) =>
  useQuery({
    enabled: !!buildingId,
    queryFn: async ({ signal }) => {
      const response = await authAPI.get<ClientFieldsResponse>('/client/fields', {
        params: { buildingId },
        signal,
      })
      return response.data
    },
    queryKey: getClientFieldsQueryKey(buildingId),
    staleTime: STALE_TIME,
  })

export const useGetYardiPropertyIds = (buildingId?: number, isYardiProperty?: boolean) =>
  useQuery({
    enabled: !!buildingId && !!isYardiProperty,
    queryFn: async ({ signal }) => {
      const response = await authAPI.get<YardiPropertyIdItem[]>('/yardi/property-id', {
        params: { buildingId },
        signal,
      })
      return response.data
    },
    queryKey: getYardiPropertyIdsQueryKey(buildingId),
    staleTime: STALE_TIME,
  })
